const func = ($target) => {
	var $sidebar = $($target.data("target")),
		$cols = $('[data-id="productColumns"]'),
		$flash = $("[data-flash-ui]"),
		$cardCol = $cols.find('[data-id="store-card-col"]'),
		$hideText = $target.data("text-hide"),
		$showText = $target.data("text-show"),
		$window = $(window);

	$target.on("click", function (e) {
		e.preventDefault();
		if ($sidebar.hasClass("d-none")) {
			$sidebar.removeClass("d-none");
			$target.find("span").text($hideText);
			$cols.removeClass("lg-cols-4").addClass("lg-cols-3");
			// $cardCol.removeClass("col-lg-3").addClass("col-lg-4");
		} else {
			$sidebar.addClass("d-none");
			$target.find("span").text($showText);
			$cols.removeClass("lg-cols-3").addClass("lg-cols-4");
			// $cardCol.removeClass("col-lg-4").addClass("col-lg-3");
		}
		$flash.each(function () {
			var $this = $(this),
				fadeSpeed = parseInt($this.data("flash-ui"));
			$this.fadeOut(0).fadeIn(fadeSpeed);
		});
	});

	if ($window.width() <= window.smBreakpoint) {
		$target.trigger("click");
	}

	// if ($target.data("state") == "closed") {
	// 	$target.trigger("click");
	// }
};

export default func;
